import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse } from '@/types/api'

import type {
  FeriasCalendarioItem,
  FeriasCalendarioParams,
  FeriasResumo,
  FeriasResumoParams,
} from '../types/feriasCalendario'

/** Remove os filtros vazios ("Todos") — a API trata parâmetro ausente como sem filtro. */
function compact(params: Record<string, string | number>): Record<string, string | number> {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== ''))
}

export const feriasCalendarioApi = {
  calendario: async (params: FeriasCalendarioParams): Promise<FeriasCalendarioItem[]> => {
    const response = await httpClient.get<ApiResponse<FeriasCalendarioItem[]>>(
      '/ferias/calendario',
      { params: compact({ ...params }) },
    )
    return unwrap(response)
  },
  resumo: async (params: FeriasResumoParams): Promise<FeriasResumo> => {
    const response = await httpClient.get<ApiResponse<FeriasResumo>>('/ferias/resumo', {
      params: compact({ ...params }),
    })
    return unwrap(response)
  },
}
